/**
 * Generates CSS styles to remove focus outlines from chart elements
 * @param className - The chart container className
 * @returns Style string to be inserted in a <style> tag
 */
export function getChartFocusStyles(className: string): string {
  return `
    .${className} *:focus,
    .${className} *:focus-visible {
      outline: none !important;
    }
    .${className} svg {
      outline: none !important;
    }
  `;
}

/**
 * Calculates the position for the chevron indicator
 * @param activeIndex - Index of the active data point
 * @param dataLength - Total number of data points
 * @param leftMargin - Left margin of the chart
 * @param rightMargin - Right margin of the chart
 * @returns CSS left position string
 */
export function getChevronPosition(
  activeIndex: number,
  dataLength: number,
  leftMargin: number = 27,
  rightMargin: number = 55
): string {
  // The chevron should align with the data points on the chart
  return `calc(${leftMargin}px + (100% - ${leftMargin + rightMargin}px) * ${activeIndex / (dataLength - 1)})`;
}
